import { gql } from '@apollo/client';

export const MUTATION_START_BIG_QUERY_SYNC_PREVIEW = gql`
  mutation StartBigQuerySyncPreview {
    startBigQuerySyncPreview {
      blocked
      drift
      job {
        id
        status
        progress_label
        error
        blocked_reason
        drift_json
        stats_json
      }
    }
  }
`;

export const MUTATION_APPROVE_BIG_QUERY_SYNC_JOB = gql`
  mutation ApproveBigQuerySyncJob($jobId: String!) {
    approveBigQuerySyncJob(jobId: $jobId) {
      id
      status
    }
  }
`;

export const MUTATION_REJECT_BIG_QUERY_SYNC_JOB = gql`
  mutation RejectBigQuerySyncJob($jobId: String!) {
    rejectBigQuerySyncJob(jobId: $jobId) {
      id
      status
    }
  }
`;
